<template>
  <v-dialog v-model="toggle" width="500" persistent>
    <v-card>
      <v-card-text
        :class="{
          'pre-formatted': preformatted
        }"
        >{{ dialogText }}</v-card-text
      >

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="confirmDialog"
          color="red"
          flat
          @click="declineButtonClick"
        >
          {{ declineButtonText }}
        </v-btn>
        <v-btn :color="color" flat @click="buttonClick">
          {{ buttonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ResponseDialog',
  props: {
    toggle: Boolean,
    dialogText: String,
    color: String,
    buttonText: String,
    declineButtonText: String,
    declineButtonClick: Function,
    buttonClick: Function,
    confirmDialog: {
      type: Boolean,
      default: false
    },
    preformatted: Boolean
  }
}
</script>

<style lang="scss">
.pre-formatted {
  white-space: pre-line;
}
</style>
